import { render, staticRenderFns } from "./PrintJournalKasbon.vue?vue&type=template&id=550166ae"
import script from "./PrintJournalKasbon.vue?vue&type=script&lang=js"
export * from "./PrintJournalKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports